import React from 'react';
import ReactDOM from 'react-dom/client';

// Bundled from npm rather than a CDN: this runs inside a Flutter WebView where
// a blocked or offline CDN would leave the table unstyled.
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
